import { differenceInDays } from 'date-fns';
import { FC, memo, useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import FourZeroFourComponent from 'src/components/FourZeroFourComponent';
import LicenseContext from 'src/contexts/LicenseContext';
import { DateModel } from 'src/models/DateModel';

import V2ShipmentOrderLegsPresenter from './V2ShipmentOrderLegsPresenter';

const V2ShipmentOrderLeg: FC = memo(() => {
  const { startOn, endOn } = useParams();
  const navigate = useNavigate();
  const context = useContext(LicenseContext);

  useEffect(() => {
    if (!context.config?.on) return;

    if (startOn) {
      const paramsOnModel = new DateModel(startOn);
      let paramsendDateModel = new DateModel(endOn);
      const dateDiff = differenceInDays(new Date(endOn), new Date(startOn));
      if (dateDiff < 0 || dateDiff > 30) {
        paramsendDateModel = new DateModel(startOn);
      }

      if (paramsOnModel.isValid()) {
        void navigate(`/shipment-order-legs/${paramsOnModel.toString()}/${paramsendDateModel.toString()}`);
        return;
      }
    }

    const configOnModel = new DateModel(context.config.on);

    if (configOnModel.isValid()) {
      void navigate(`/shipment-order-legs/${configOnModel.toString()}/${configOnModel.toString()}`);
      return;
    }

    void navigate('/404');
  }, [startOn, endOn, context.config, navigate]);

  if (!startOn) return <FourZeroFourComponent />;

  return <V2ShipmentOrderLegsPresenter startDate={startOn} endDate={endOn} />;
});

export default V2ShipmentOrderLeg;
